import React, { useCallback, useState } from "react";
import { TaleBorderFul } from "@components/TaleBorderFul";
import Select from "react-select";

export const TaleSelect = ({
  value,
  onChange,
  width = "100%",
  height = 51,
  role = "normal",
  label = "",
  labelClassName = "",
  className = "",
  children,
  selectClassName = "",
  multiple = false,
  ...props
}) => {
  const options = React.Children.toArray(children).map((child) => {
    if (child?.type !== "option")
      throw new Error("TaleSelect cannot have children other than option");
    return {
      label: child.props.children,
      value: child.props.value,
      isDisabled: child.props.disabled
    };
  });
  const [internalValue, setinternalValue] = useState(multiple ? [] : (options.at(0) ?? null));

  const normalizeValue = useCallback(() => {
    if (multiple) {
      if (!Array.isArray(value)) return [];
      return options.filter((opt) => value.includes(opt.value));
    }
    return options.find((opt) => opt.value === value) || null;
  }, [multiple, options, value]);

  const handleChange = (selected) => {
    const value = multiple
      ? selected?.map((opt) => opt.value) ?? []
      : selected.value ?? "";
    if (!onChange) {
      setinternalValue(
        multiple ? value : options.find((e) => e.value === value)
      );
    } else onChange({ target: { ...props, value } });
  };

  return (
    <div className={`flex flex-col gap-1 ${className ?? ""}`}>
      {label && (
        <span className={`font-semibold text-sm ${labelClassName ?? ""}`}>
          {label}
        </span>
      )}
      <TaleBorderFul role={role} width={width} height={height}>
        <div className="w-full z-30">
          <Select
            menuPortalTarget={
              typeof window !== "undefined" ? document.body : null
            }
            menuPosition="fixed"
            classNamePrefix="tale-select"
            className={selectClassName}
            value={!onChange ? internalValue : normalizeValue()}
            onChange={handleChange}
            isMulti={multiple}
            options={options}
            styles={{
              control: (base) => ({
                ...base,
                minHeight: height,
                border: "none",
                boxShadow: "none",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
              indicatorSeparator: () => ({ display: "none" }),
            }}
            {...props}
          />
        </div>
      </TaleBorderFul>
    </div>
  );
};
